import React, { useCallback } from "react";
import PropTypes from "prop-types";
import BreadcrumbList from "..//breadcrumb-list";
import { appUrl } from "../../../constants/url-constants";

const EChallanBreadCrumb = ({
    stateName = "",
    stateSlug = ""
}) => {

    const onBreadcrumbClick = ({ item }) => {
        if (item === "home") {
            window.location.href = `${appUrl()}/`;
        } else {
            window.location.href = `${appUrl()}${item.redirectURL}`;
        }
    };

    const computeBreadcrumbList = useCallback(() => {
        const list = [
            {
                displayText: "eChallan",
                ...(stateName && { redirectURL: "/traffic-challan/" })
            }
        ];

        if (stateName && stateSlug) {
            list.push({
                displayText: `${stateName} Traffic Challan`
            });
        }

        return list;
    }, [stateName, stateSlug]);

    return (
        <div className="cvh">
            <BreadcrumbList
                homeText={"Home"}
                isRevamped={true}
                attachSchema={true}
                onClickCallback={onBreadcrumbClick}
                list={computeBreadcrumbList()}
            />
        </div>
    );
};

EChallanBreadCrumb.propTypes = {
    stateName: PropTypes.string,
    stateSlug: PropTypes.string
};

export default EChallanBreadCrumb;
